import { render, staticRenderFns } from "./SubmitBtn.vue?vue&type=template&id=bfda06f4&scoped=true&"
import script from "./SubmitBtn.vue?vue&type=script&lang=js&"
export * from "./SubmitBtn.vue?vue&type=script&lang=js&"
import style0 from "./SubmitBtn.vue?vue&type=style&index=0&id=bfda06f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfda06f4",
  null
  
)

export default component.exports